/* import __COLOCATED_TEMPLATE__ from './appointment-section.hbs'; */
import { dateFormat } from 'client-portal/utils/date-time';
import { formatMoney } from 'client-portal/helpers/format-money';
import { modifier } from 'ember-modifier';
import { service } from '@ember/service';
import Component from '@glimmer/component';
import styles from './appointment-section.module.scss';

export default class SiteBillingOutOfNetworkFormAppointmentSection extends Component {
  @service store;
  @service currentPractice;

  styles = styles;
  dateFormat = dateFormat;

  get appointment() {
    return this.args.appointment;
  }

  get office() {
    return this.appointment?.office;
  }

  get placeOfService() {
    return (
      this.office?.insurancePlaceOfService ||
      this.currentPractice.get('defaultOffice.insurancePlaceOfService')
    );
  }

  get rows() {
    return [
      {
        label: 'Date',
        value: this.appointment?.startTime.format(this.dateFormat),
      },
      {
        label: 'Place of service',
        value: this.placeOfService,
        tooltip:
          'The location where your provider has determined health services and health related services are provided',
      },
      {
        label: 'Service',
        value: `<div class="cpt-code">${this.appointment?.cptCode}</div>
                <div class="service-description">${this.appointment?.serviceDescription}</div>`,
      },
      {
        label: 'Units',
        value: this.appointment?.units,
      },
      {
        label: 'Fee',
        value: formatMoney([this.appointment?.fee], { precision: 2 }),
      },
    ];
  }

  onInsert = modifier(
    () => {
      this.args.onTrack('review');
    },
    { eager: false }
  );
}
